import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Languages } from "lucide-react";

export default function TherapistCard({ therapist, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="tile group flex h-full flex-col p-5 text-center transition-transform duration-500 hover:-translate-y-1.5"
      data-testid={`therapist-card-${therapist.id}`}
    >
      <div className="relative overflow-hidden rounded-2xl">
        <img
          src={therapist.image}
          alt={`Portrait of ${therapist.name}`}
          className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          loading="lazy"
        />
      </div>

      <div className="flex flex-1 flex-col pt-5">
        <h3 className="font-serif text-2xl font-bold tracking-tight">{therapist.name}</h3>
        <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {therapist.credentials}
          {therapist.experience ? ` · ${therapist.experience}` : ""}
        </p>
        <p className="mt-3 flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
          <Languages className="h-3.5 w-3.5 text-accent" />
          {therapist.languages.join(" · ")}
        </p>
        <p className="mt-3 text-sm leading-relaxed text-foreground/80">{therapist.expertise.slice(0, 2).join(" · ")}</p>

        <div className="mt-auto flex items-center justify-center gap-3 pt-6">
          <Link
            to={`/therapists/${therapist.id}`}
            data-testid={`therapist-view-${therapist.id}`}
            className="rounded-full border border-primary/20 px-4 py-2 text-xs font-bold transition-all duration-300 hover:bg-primary hover:text-primary-foreground"
          >
            View profile
          </Link>
          <Link
            to={`/book/${therapist.id}`}
            data-testid={`therapist-book-${therapist.id}`}
            className="flex items-center gap-1.5 rounded-full bg-primary px-4 py-2 text-xs font-bold text-primary-foreground transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            Book <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </motion.article>
  );
}
